import React, { useEffect } from "react";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import WorkingProcess from "../Section/WorkingProcess";
import { FaUserMd, FaHeart, FaClinicMedical, FaHospital } from "react-icons/fa";
import { Link } from "react-router-dom";
import styled from "styled-components";
import FaqSectionStyle4 from "../FaqSection/FaqSectionStyle4";
import Spacing from "../Spacing";
import Post from "../Post";
import { Helmet } from "react-helmet";
const workingProcessData = [
  {
    title: "Ovarian Stimulation",
    subTitle:
      "Ovarian stimulation is a crucial part of the IVF process. It involves using medications to stimulate your ovaries, encouraging the development of multiple eggs for retrieval and fertilization..",
    iconUrl: "/images/home_2/department_icon3.png",
    number: "01",
  },
  {
    title: "Oocyte maturation",
    subTitle:
      "Oocyte maturation involves hormone treatments <br /> to ensure eggs reach full maturity, making <br />them ready for retrieval, fertilization, and<br /> subsequent  embryo development, which<br /> are crucial steps in the IVF process.",
    iconUrl: "/images/home_2/department_icon4.png",
    number: "02",
  },
  {
    title: "Egg Retrieval",
    subTitle:
      "Egg retrieval involves collecting mature eggs from the ovaries through a minor surgical procedure, allowing them to be fertilized in the lab as part of the IVF process.",
    iconUrl: "/images/home_2/department_icon25.png",
    number: "03",
  },
  {
    title: "Fertilization",
    subTitle:
      "All mature eggs are fertilized using intracytoplasmic sperm injection (ICSI), where sperm is injected directly into each mature egg. On average, about 70% of these mature eggs will successfully fertilize. The fertilized egg then develops into an embryo.",
    iconUrl: "/images/home_2/department_icon6.png",
    number: "04",
  },
  {
    title: "Embryo transfer",
    subTitle:
      "Embryo transfer is the final step in the IVF process. It involves placing the fertilized embryo into the uterus, where it can implant and develop into a successful pregnancy.",
    iconUrl: "/images/home_2/department_icon7.png",
    number: "05",
  },
  {
    title: "Cryopreservation of the left embryos",
    subTitle:
      "Cryopreservation involves freezing the left embryos after fertilization through ICSI. These embryos are stored in liquid nitrogen, ensuring they are available for future use. This process increases the chances of a successful pregnancy in later attempts, reducing the need for repeated ICSI cycles.",
    iconUrl: "/images/home_2/department_icon28.png",
    number: "06",
  },
];
const faqData = [
  {
    title: "What is ICSI and how does it differ from traditional IVF ?",
    content:
      "ICSI, or Intracytoplasmic Sperm Injection, is a specialized form of IVF where a single sperm is directly injected into an egg to facilitate fertilization. Unlike traditional IVF, where eggs and sperm are combined in a petri dish and fertilization occurs naturally, ICSI is used to overcome severe male infertility issues by manually assisting the fertilization process.",
  },
  {
    title: "Who can benefit from ICSI treatment ?",
    content:
      "ICSI is particularly beneficial for couples facing severe male factor infertility, such as low sperm count, poor sperm motility, or abnormal sperm morphology. It is also useful for those with previous failed IVF cycles with poor fertilization rates, obstructive azoospermia (blocked sperm ducts) where sperm must be retrieved directly from the testes, unexplained infertility where traditional IVF has not been successful, and cases where eggs need to be fertilized with frozen or surgically retrieved sperm.",
  },
  {
    title: "What is the success rate of ICSI compared to conventional IVF ?",
    content:
      "ICSI typically results in high fertilization rates, with about 70-80% of injected eggs becoming fertilized. However, the overall success rates in terms of pregnancy and live birth are similar to those of conventional IVF, depending on various factors including the woman’s age, the quality of the eggs and sperm, and the overall health of the embryos.",
  },
  {
    title: "What are the steps involved in the ICSI procedure ?",
    content:
      "The ICSI procedure involves several steps: Ovarian Stimulation, where hormonal medications stimulate the ovaries to produce multiple eggs; Egg Retrieval, a minor surgical procedure to collect mature eggs from the ovaries; Sperm Collection and Preparation, where sperm is collected and prepared for injection; the ICSI Procedure, where a single sperm is injected directly into each mature egg using a fine needle under a microscope; Embryo Culture, where the fertilized eggs (embryos) are cultured in the lab for several days; Embryo Transfer, where one or more healthy embryos are transferred into the uterus; and a Pregnancy Test, a blood test performed approximately two weeks after the embryo transfer to confirm pregnancy.",
  },
  {
    title: "Are there any risks or side effects associated with ICSI ?",
    content:
      "ICSI is a safe and effective procedure, but there are potential risks and side effects, including Ovarian Hyperstimulation Syndrome (OHSS), a condition where the ovaries become swollen and painful after stimulation; multiple pregnancies, with a higher risk of twins if multiple embryos are transferred; egg damage, which is rare but can occur during the injection process; genetic concerns, with a slightly increased risk of genetic or chromosomal abnormalities although this risk is low; emotional stress, as the process can be emotionally challenging and counseling is recommended to help manage stress and anxiety; and side effects from medications, such as mild side effects like bloating, mood swings, and headaches from fertility medications.",
  },
];
const relatedBlog = [
  {
    title:
      "The Importance of Mental Health: Understanding and Managing Anxiety Disorders",
    thumbUrl: "/images/blog/post_1.jpeg",
    date: "March 12",
    btnText: "Learn More",
    href: "/blog/blog-details",
  },

];
export default function IVF() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('cs_active');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.cs_reveal').forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  // pageTitle("IVF");
  return (
    <>
      <Helmet>
        <title>ICSI – Precision Fertility for Male Factor Infertility</title>
        <meta name="description" content="ICSI treatment to assist male infertility by directly injecting sperm into the egg for higher fertilization success" />
        <meta name="keywords" content="ICSI treatment, male infertility, sperm injection, assisted reproduction" />
        <link rel="canonical" href="https://jabalpurivfcentre.com/ICSI" />
      </Helmet>
      <Container>
        <BannerSectionStyle3
          bgUrl="/images/ICSI.jpeg"
          // imgUrl="/images/about/banner_img.png"
          title="Welcome to <br /> Pluro Jabalpur<br /> Fertility Center"
          subTitle="ICSI (Intracytoplasmic Sperm Injection)"
        />

        {/* Introduction Section */ }
        <Section topMd={ 200 } topLg={ 150 } topXl={ 110 }>
          <div className="container">
            <div className="row cs_gap_y_40">
              <div className="col-lg-12">
                <div className="cs_iui_intro">
                  <div className="row cs_gap_y_30 align-items-center">
                    <div className="col-lg-6">
                      <div className="cs_section_badge mb-3">About ICSI</div>
                      <h1 className="heading mb-4">
                        Advanced ICSI Treatments at Jabalpur Fertility Centre
                      </h1>
                      <p className="mb-4">
                        Intracytoplasmic Sperm Injection (ICSI) is a specialized form of in vitro fertilization (IVF) designed to address severe male factor infertility. At Jabalpur Fertility Centre, recognized as the Best Fertility Clinic in Jabalpur, we offer cutting-edge ICSI treatments under the expert guidance of Dr. Archana Shrivastava, the Best IVF Doctor in Jabalpur. Our mission is to provide personalized, compassionate care and the best possible outcomes for couples facing fertility challenges.
                      </p>
                    </div>
                    <div className="col-lg-6">
                      <div className="cs_iui_highlight_box">
                        <h2>What is ICSI?</h2>
                        <p>
                          ICSI is a highly precise laboratory procedure where a single sperm is directly injected into an egg to achieve fertilization. This technique bypasses many of the barriers to fertilization encountered in traditional IVF and is particularly beneficial for couples with significant male infertility issues.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* When is ICSI Recommended */ }
                <div className="cs_iui_recommended" style={ { marginTop: '80px' } }>
                  <h2 className="text-center cs_fs_40 cs_medium mb-3">When is ICSI Recommended?</h2>
                  <p className="text-center mb-5">
                    ICSI is often recommended in the following situations:
                  </p>

                  <div className="cs_iui_grid">
                    <div className="cs_recommended_card">
                      <div className="cs_rc_icon">01</div>
                      <div className="cs_rc_title">Severe Male Infertility</div>
                      <p className="cs_rc_desc">Including very low sperm count, poor motility, or abnormal sperm morphology.</p>
                    </div>

                    <div className="cs_recommended_card">
                      <div className="cs_rc_icon">02</div>
                      <div className="cs_rc_title">Previous Failed Fertilization</div>
                      <p className="cs_rc_desc">When fertilization has not occurred in previous IVF attempts.</p>
                    </div>

                    <div className="cs_recommended_card">
                      <div className="cs_rc_icon">03</div>
                      <div className="cs_rc_title">Use of Frozen Sperm</div>
                      <p className="cs_rc_desc"></p>
                    </div>

                    <div className="cs_recommended_card">
                      <div className="cs_rc_icon">04</div>
                      <div className="cs_rc_title">Uss Of Frozen Eggs</div>
                      <p className="cs_rc_desc">Using previously frozen eggs for fertilization.</p>
                    </div>

                    <div className="cs_recommended_card">
                      <div className="cs_rc_icon">05</div>
                      <div className="cs_rc_title">Tesa/Pesa</div>
                      <p className="cs_rc_desc">Sperm retrieved from testicular or epididymal aspiration are fertilized by ICSI.</p>
                    </div>

                    <div className="cs_recommended_card">
                      <div className="cs_rc_icon">06</div>
                      <div className="cs_rc_title">Unexplained Infertility</div>
                      <p className="cs_rc_desc">When no specific cause of infertility is identified after a complete fertility workup.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Section>

        {/* How ICSI Works */ }
        <Section
          topMd={ 120 }
          topLg={ 100 }
          topXl={ 80 }
          bottomMd={ 120 }
          bottomLg={ 100 }
          bottomXl={ 80 }
        >
          <WorkingProcess
            sectionTitle="How ICSI Works"
            sectionTitleUp=""
            sectionTitleDown=""
            sectionSubTitle=""
            data={ workingProcessData }
          />
        </Section>

        {/* Success Factors Section */ }
        <Section bottomMd={ 100 } bottomLg={ 80 } bottomXl={ 60 }>
          <div className="container">
            <div className="cs_ivf_factors_section_premium">
              <div className="row align-items-center cs_relative_z1">
                <div className="col-lg-5">
                  <div className="cs_factors_left_premium">
                    <div className="cs_section_badge_premium">ICSI Success Factors</div>
                    <h2 className="cs_section_title_premium">Success Rates and Factors Affecting ICSI</h2>
                    <p className="cs_section_desc_premium">
                      Success rates for ICSI can vary based on several factors, including:
                    </p>
                    <div className="cs_factors_img_wrap">
                      <img src="/images/about/Dr.Archana.png" alt="ICSI Success Factors" className="cs_factors_img" />
                    </div>
                  </div>
                </div>
                <div className="col-lg-7">
                  <div className="cs_factors_grid_premium">
                    <div className="cs_factor_card_premium">
                      <div className="cs_factor_num_premium">01</div>
                      <div className="cs_factor_content_premium">
                        <h3>Age of the Woman</h3>
                        <p>Younger women generally have higher success rates.</p>
                      </div>
                    </div>
                    <div className="cs_factor_card_premium">
                      <div className="cs_factor_num_premium">02</div>
                      <div className="cs_factor_content_premium">
                        <h3>Quality of Eggs and Sperm</h3>
                        <p>Healthy eggs and sperm increase the likelihood of successful fertilization and embryo development.</p>
                      </div>
                    </div>
                    <div className="cs_factor_card_premium">
                      <div className="cs_factor_num_premium">03</div>
                      <div className="cs_factor_content_premium">
                        <h3>Underlying Fertility Issues</h3>
                        <p>Some conditions may affect the success rates of ICSI.</p>
                      </div>
                    </div>
                    <div className="cs_factor_card_premium">
                      <div className="cs_factor_num_premium">04</div>
                      <div className="cs_factor_content_premium">
                        <h3>Number of ICSI Cycles</h3>
                        <p>Success rates often increase with multiple cycles.</p>
                      </div>
                    </div>
                    <div className="cs_factor_card_premium">
                      <div className="cs_factor_num_premium">05</div>
                      <div className="cs_factor_content_premium">
                        <h3>Lifestyle Factors</h3>
                        <p>Maintaining a healthy lifestyle can positively impact ICSI outcomes.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Section>

        {/* Why Choose Us Section */ }
        <Section bottomMd={ 80 } bottomLg={ 60 } bottomXl={ 40 }>
          <div className="container">
            <div className="cs_premium_why_choose">
              <div className="cs_premium_section_header">
                <div className="cs_premium_badge">Why Choose Us</div>
                <h2>Why Choose Jabalpur Fertility Centre for ICSI ?</h2>
                <p>We offer world-class treatment with a compassionate approach, ensuring you receive the best care possible on your journey to parenthood.</p>
              </div>

              <div className="row cs_gap_y_40 justify-content-center" style={ { display: 'flex', flexWrap: 'wrap' } }>
                <div className="col-lg-4 col-md-6">
                  <div className="cs_why_card_premium">
                    <div className="cs_wcp_icon">
                      <FaUserMd />
                    </div>
                    <h3>Expertise and Experience</h3>
                    <p>Led by Dr. Archana Shrivastava, our team has extensive experience in performing successful ICSI procedures.</p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="cs_why_card_premium">
                    <div className="cs_wcp_icon">
                      <FaHeart />
                    </div>
                    <h3>Personalized Care</h3>
                    <p>We tailor our treatment plans to meet the unique needs of each couple, ensuring the best possible outcomes.</p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="cs_why_card_premium">
                    <div className="cs_wcp_icon">
                      <FaClinicMedical />
                    </div>
                    <h3>Comprehensive Fertility Services</h3>
                    <p>From initial consultation and complete fertility workup to advanced treatments like IVF and ICSI, we offer a full spectrum of fertility services.</p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="cs_why_card_premium">
                    <div className="cs_wcp_icon">
                      <FaHospital />
                    </div>
                    <h3>State-of-the-Art Facility</h3>
                    <p>Our clinic is equipped with the latest technology and facilities to provide top-notch fertility care.</p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="cs_why_card_premium">
                    <div className="cs_wcp_icon">
                      <FaClinicMedical />
                    </div>
                    <h3>Patient-Centered Approach</h3>
                    <p>We prioritize your comfort and well-being, offering compassionate support throughout your fertility journey.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Section>

        {/* FAQ Section */ }
        <Section topMd={ 40 } topLg={ 20 } topXl={ 0 }>
          <div className="cs_iui_faq_wrapper">
            <FaqSectionStyle4
            sectionTitle="Frequently Asked <br />Questions"
            data={ faqData }
            faqImgUrl="/images/home_4/faq_img.jpg"
            spiningImgUrl="/images/home_1/about_mini.svg"
          />
          </div>
        </Section>

        {/* Contact Us Section */ }
        <Section topMd={ 60 } topLg={ 40 } topXl={ 20 } bottomMd={ 100 } bottomLg={ 80 } bottomXl={ 60 }>
          <div className="container cs_reveal">
            <div className="cs_ivf_contact_banner" style={ { background: '#c77842', borderRadius: '20px', padding: '60px 50px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '30px' } }>
              <div className="cs_icc_content" style={ { flex: '1', minWidth: '300px' } }>
                <h2 style={ { color: '#fff', fontSize: '36px', marginBottom: '15px', fontWeight: '700' } }>Contact Us</h2>
                <p style={ { color: 'rgba(255,255,255,0.9)', fontSize: '18px', margin: '0', lineHeight: '1.6' } }>
                  If you are considering ICSI as a fertility treatment option,
                  contact Pluro Jabalpur Fertility Centre today. Our expert team is
                  here to guide you through the process and help you achieve
                  your dream of starting a family.
                </p>
              </div>
              <div className="cs_icc_action">
                <Link to="/contact" className="cs_btn" style={ { background: '#fff', color: '#c77842', padding: '15px 40px', borderRadius: '50px', fontWeight: '600', fontSize: '18px', display: 'inline-flex', alignItems: 'center', textDecoration: 'none', boxShadow: '0 10px 20px rgba(0,0,0,0.1)' } }>
                  <span>Get in Touch</span>
                </Link>
              </div>
            </div>
          </div>
        </Section>
        <Section bottomMd={ 200 } bottomLg={ 150 } bottomXl={ 110 }>
          <div className="container">
            <h2 className="mb-0 cs_fs_40 cs_medium">Related Articles</h2>
            <Spacing md="57" />
            <div className="row cs_gap_y_40">
              { relatedBlog?.map((item, index) => (
                <div className="col-xl-12" key={ index }>
                  <Post { ...item } />
                </div>
              )) }
            </div>
          </div>
        </Section>
      </Container>
    </>
  );
}

const Container = styled.div`
  .margin {
    margin-left: 25px;
  }
  .heading{
    font-size: 32px;
     @media (max-width: 991px) {
      font-size: 28px;
    }
  }
`;
